import React from "react";
import urls from "../../../constants";

const TableHeader = ({ productConfigVariant }) => {
    return (
        <thead>
            <tr>
                {productConfigVariant?.map((item, index) => {
                    if (urls?.HIDDEN_FIELDS_GROUP?.includes(item?.groupId)) return null;
                    return (
                        <th key={index}>
                            {item?.variantName}
                        </th>
                    );
                })}
                <th>Unit Price</th>
                <th>Quote Qty</th>
                <th>Released Qty</th>
                <th>LPO Qty</th>
                <th>Margin</th>
                <th>Total Price</th>
                <th>Notes</th>
            </tr>
        </thead>
    );
};
export default TableHeader